// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const sandslash: PokeData = {
  "id": 28,
  "name": "sandslash",
  "height": 10,
  "weight": 295,
  "base_experience": 158,
  "types": [
    PokeType.GROUND
  ],
  "api_moves": [
    "scratch",
    "swords-dance",
    "sand-attack",
    "poison-sting",
    "counter",
    "earthquake",
    "dig",
    "agility",
    "defense-curl",
    "swift",
    "fury-swipes",
    "slash",
    "protect",
    "sandstorm",
    "rollout",
    "fury-cutter",
    "magnitude",
    "rapid-spin",
    "crush-claw",
    "sand-tomb",
    "gyro-ball",
    "bulldoze"
  ],
  "moves": [
    "scratch",
    "earthquake",
    "protect",
    "sandstorm",
    "magnitude",
    "bonemerang",
    "bone-throw",
    "mud-slap",
    "mud-shot",
    "rototiller",
    "fissure",
    "earth-power",
    "mud-bomb"
  ],
  "evolution_chain": {
    "id": 11,
    "item": null,
    "species": [
      {
        "name": "sandshrew",
        "order": 28,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "sandslash",
        "order": 29,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": 27,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 22,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "ice-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 129,
    "speed": 107,
    "ability_power": 164
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
